import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WelcomePage from "./features/welcome";
import Dashboard from "./features/dashboard";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import React from "react";
import UnderWriterDashboard from "./features/underwriter/UnderWriterDashboard";
import RedirectToDashboard from "./features/welcome/components/RedirectToDashboard";
import CallbackPage from "./features/claims/CallbackPage";
import LoggedOutPage from "./features/logged-out";
import AdminLoginPage from "./features/admin-login";
import DocumentTitle from "./components/DocumentTitle";
import WorkspaceRedirect from "./components/WorkspaceRedirect";

function App() {
  return (
    <div className="App">
      <Router>
          <DocumentTitle />
          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <WelcomePage />
                </PublicRoute>
              }
            />
            {/* <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            /> */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/login"
              element={
                <PublicRoute>
                  <AdminLoginPage />
                </PublicRoute>
              }
            />
            <Route path="/logged-out" element={<LoggedOutPage />} />
            <Route path="/workspace" element={<WorkspaceRedirect />} />
            <Route
              path="/redirectToICEClaim/:token/:username/:userRole/:userIdData"
              element={<RedirectToDashboard />}
            />
            <Route
              path="/underwriter/:claimId"
              element={<UnderWriterDashboard />}
            />
            <Route path="/claims" element={<CallbackPage />} />
          </Routes>
      </Router>
    </div>
  );
}

export default App;
